(() => {
  const observers = new WeakMap();
  const initialise = (root) => {
    if (!root || root.dataset.motionInit) return;
    root.dataset.motionInit = 'true';
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const items = [...root.querySelectorAll('[data-reveal]')];
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove('will-reveal');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.04, rootMargin: '0px 0px -20px 0px' });
    root.classList.add('motion-ready');
    items.forEach((item) => {
      if (item.getBoundingClientRect().top < innerHeight) return;
      item.classList.add('will-reveal');
      observer.observe(item);
    });
    root.addEventListener('focusin', (event) => {
      const item = event.target.closest('[data-reveal]');
      if (item) {
        item.classList.remove('will-reveal');
        observer.unobserve(item);
      }
    });
    observers.set(root, observer);
  };
  document.querySelectorAll('.dor-home-v2').forEach(initialise);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target.querySelector('.dor-home-v2')));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('.dor-home-v2');
    if (root) observers.get(root)?.disconnect();
  });
})();
